export const buyerRoutes = [
  {
    path: '/buyer/login',
    name: 'buyer-login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/buyer/signup',
    name: 'buyer-signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/SignUp.vue')
  },
  {
    path: '/buyer',
    component: () => import(/* webpackChunkName: "PageWrapper" */ '../views/PageWrapper.vue'),
    children: [
      {
        path: '/buyer/search',
        name: 'search',
        component: () => import(/* webpackChunkName: "search" */ '../views/private/Search.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/rfp-List',
        name: 'buyer-rfp-list',
        component: () => import(/* webpackChunkName: "buyer-rfp-list" */ '../views/private/BuyerRfpList.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/rfps-messages',
        name: 'buyer-rfps-messages',
        component: () => import(/* webpackChunkName: "buyer-rfps-messages" */ '../views/private/BuyerRfpsMessages.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/bookmarks',
        name: 'buyer-bookmarks',
        component: () => import(/* webpackChunkName: "bookmarks" */ '../views/private/Bookmarks.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/account-settings',
        name: 'buyer-account-settings',
        component: () => import(/* webpackChunkName: "buyer-account-settings" */ '../views/private/AccountSettings.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/support',
        name: 'buyer-support',
        component: () => import(/* webpackChunkName: "support" */ '../views/private/Support.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/payment-summary',
        name: 'payment-summary',
        component: () => import(/* webpackChunkName: "payment-summary" */ '../components/payments/paymentSummary.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/buyer/rfp-form',
        name: 'rfp-form',
        component: () => import(/* webpackChunkName: "rfp-form" */ '../views/private/RequestProposalForm.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      },
      {
        path: '/companies/shortlist',
        name: 'shortlist-companies',
        component: () => import(/* webpackChunkName: "search" */ '../components/companies/ShortList.vue'),
        meta: {
          requiredAuth: true,
          role: '3'
        }
      }
    ]
  }
]
